import {
  GET_LEGALITYASSET,
  GET_LEGALITYASSET_SUCCESS,
  GET_LEGALITYASSET_FAIL,
  DELETE_LEGALITYASSET,
  DELETE_LEGALITYASSET_SUCCESS,
  DELETE_LEGALITYASSET_FAIL,
  UPDATE_LEGALITYASSET,
  UPDATE_LEGALITYASSET_SUCCESS,
  UPDATE_LEGALITYASSET_FAIL,
  ADD_NEW_LEGALITYASSET,
  ADD_LEGALITYASSET_SUCCESS,
  ADD_LEGALITYASSET_FAIL,
  LEGALITYASSET_LOADING,
  LEGALITYASSET_RESET
} from "./actionType";

export const resetLegalityAssetState = (actionType) => ({
  type: LEGALITYASSET_RESET,
  payload: { actionType },
});

export const getLegalityAssetSuccess = (actionType, data) => ({
  type: GET_LEGALITYASSET_SUCCESS,
  payload: { actionType, data },
});

export const getLegalityAssetFail = (actionType, error) => ({
  type: GET_LEGALITYASSET_FAIL,
  payload: { actionType, error },
});

export const getLegalityAsset = data => ({
  type: GET_LEGALITYASSET,
  payload: data,
});

export const getLegalityAssetLoading = () => ({
  type: LEGALITYASSET_LOADING
});

export const deleteLegalityAsset = data => ({
  type: DELETE_LEGALITYASSET,
  payload: data,
});

export const deleteLegalityAssetSuccess = data => ({
  type: DELETE_LEGALITYASSET_SUCCESS,
  payload: data,
});

export const deleteLegalityAssetFail = error => ({
  type: DELETE_LEGALITYASSET_FAIL,
  payload: error,
});

export const updateLegalityAsset = data => ({
  type: UPDATE_LEGALITYASSET,
  payload: data,
});

export const updateLegalityAssetFail = error => ({
  type: UPDATE_LEGALITYASSET_FAIL,
  payload: error,
});

export const updateLegalityAssetSuccess = data => ({
  type: UPDATE_LEGALITYASSET_SUCCESS,
  payload: data,
});

export const addNewLegalityAsset = data => ({
  type: ADD_NEW_LEGALITYASSET,
  payload: data,
});

export const addLegalityAssetSuccess = data => ({
  type: ADD_LEGALITYASSET_SUCCESS,
  payload: data,
});

export const addLegalityAssetFail = error => ({
  type: ADD_LEGALITYASSET_FAIL,
  payload: error,
});